import { ISuitabilityUserInvestorTypeResponse } from '../../interfaces/suitability-user-investor-type.interface';
import { SuitabilityProfileFittingAcceptResponse, SuitabilityProfileFittingResponse } from '../../models/santander-suitability/santander-suitability.model';
import { CustomerAnswer } from '../../models/suitability-santander/suitability-customer-answers.model';
import { SuitabilityCustomerProfile } from '../../models/suitability-santander/suitability-customer-profile.model';
import { Question } from '../../models/suitability-santander/suitability-questions.model';
import { SuitabilitySantanderAction } from './suitability-santander.action';

export type SuitabilityFeedbackMode = 'success' | 'error';
export type SuitabilityFeedbackSource = 'create' | 'answer' | 'accept' | null;

export class SuitabilitySantanderState {
  public pending: boolean;
  public error: any;
  public profileVersion: number;
  public questionnaireCode: number;
  public questionnaireNumber: number;
  public questions: Array<Question>;
  public customerAnswers: Array<CustomerAnswer>;
  public profileInvestorCode: string;
  public profileInvestorName: string;
  public profile: SuitabilityCustomerProfile;
  public isExcludedFromCommunication: boolean;
  public fitting: {
        data: SuitabilityProfileFittingResponse;
        pending: boolean;
        error: string;
    };
  public fittingAccept: {
        data: SuitabilityProfileFittingAcceptResponse;
        pending: boolean;
        error: string;
  };
  public investorType: {
        data: ISuitabilityUserInvestorTypeResponse;
        pending: boolean;
        error: string;
    };
  public feedbackMode: SuitabilityFeedbackMode;
  public feedbackSource: SuitabilityFeedbackSource;
}

export const initialGenericState: SuitabilitySantanderState = {
  pending: true,
  error: null,
  profileVersion: null,
  questionnaireCode: null,
  questionnaireNumber: null,
  questions: [],
  customerAnswers: [],
  profileInvestorCode: null,
  profileInvestorName: null,
  profile: null,
  isExcludedFromCommunication: null,
  investorType: {
    data: null,
    pending: false,
    error: null,
  },
  fitting: {
    data: null,
    pending: false,
    error: null,
  },
  fittingAccept: {
    data: null,
    pending: false,
    error: null,
  },
  feedbackMode: 'success',
  feedbackSource: null,
};

export function SuitabilitySantanderReducer(
  state: SuitabilitySantanderState = initialGenericState,
  action: any
) {
  switch (action.type) {
    /**
     * Quanto ao questionário
     */

    case SuitabilitySantanderAction.getQuestionsSantander:
      return { ...state, ...{ pending: true, error: null } };

    case SuitabilitySantanderAction.getQuestionsSantanderSuccess:
      return {
        ...state,
        ...{ ...action.payload, pending: false },
        feedbackMode: 'success',
        feedbackSource: 'create',
      };

    case SuitabilitySantanderAction.getQuestionsSantanderError:
      return {
        ...state,
        ...{ ...action.payload, pending: false, error: action.payload },
        feedbackMode: 'error',
        feedbackSource: 'create',
      };

    /**
     * Quanto as respostas do cliente
     */

    case SuitabilitySantanderAction.setCustomerAnswers:
      return { ...state, ...{ pending: true, error: null } };

    case SuitabilitySantanderAction.setCustomerAnswersSuccess:
      return { ...state, ...{ ...action.payload, pending: false } };

    case SuitabilitySantanderAction.setCustomerAnswersError:
      return {
        ...state,
        ...{ ...action.payload, pending: false, error: action.payload }
      };

    /**
     * Quanto ao envio do questionário respondido
     */

    case SuitabilitySantanderAction.sendCustomerAnswers:
      return { ...state, ...{ pending: true, error: null } };

    case SuitabilitySantanderAction.sendCustomerAnswersSuccess:
      return {
        ...state,
        ...{ ...action.payload, pending: false },
        feedbackMode: 'success',
        feedbackSource: 'answer',
      };

    case SuitabilitySantanderAction.sendCustomerAnswersError:
      return {
        ...state,
        ...{ ...action.payload, pending: false, error: action.payload },
        feedbackMode: 'error',
        feedbackSource: 'answer',
      };

    /**
     * Quanto ao aceite do perfil do usuario
     */

    case SuitabilitySantanderAction.acceptCustomerAnswers:
      return { ...state, ...{ pending: true, error: null } };

    case SuitabilitySantanderAction.acceptCustomerAnswersSuccess:
      return {
        ...state,
        ...{ ...action.payload, pending: false },
        feedbackMode: 'success',
        feedbackSource: 'accept',
      };

    case SuitabilitySantanderAction.acceptCustomerAnswersError:
      return {
        ...state,
        ...{ ...action.payload, pending: false, error: action.payload },
        feedbackMode: 'error',
        feedbackSource: 'accept',
      };

    /**
     * Quanto a verificacao se esta na lista para nao receber comunicacoes
     */
    case SuitabilitySantanderAction.checkClientExcludeFromCommunication:
      return { ...state, ...{ pending: true, error: null } };

    case SuitabilitySantanderAction.checkClientExcludeFromCommunicationSuccess:
      return { ...state, ...{ ...action.payload, pending: false } };

    case SuitabilitySantanderAction.checkClientExcludeFromCommunicationError:
      return {
        ...state,
        pending: false,
        isExcludedFromCommunication: null
      };

    /**
     * Quanto a busca de perfil de investidor
     */
    case SuitabilitySantanderAction.getProfileSantander:
      return { ...state, ...{ pending: true, error: null } };

    case SuitabilitySantanderAction.getProfileSantanderSuccess:
      return {
        ...state,
        pending: false,
        profile: action.payload,
        error: false,
        feedbackMode: 'success',
        feedbackSource: 'create',
      };

    case SuitabilitySantanderAction.getProfileSantanderError:
      return {
        ...state,
        ...{ ...action.payload, pending: false, error: true },
      };

    case SuitabilitySantanderAction.generateFittingProfileSuitability:
      return {
        ...state,
            fitting: {
              data: null,
              pending: true,
              error: null,
      },
    };

    case SuitabilitySantanderAction.generateFittingProfileSuitabilitySuccess:
      return {
        ...state,
          fitting: {
            data: action.payload,
            pending: false,
            error: null,
          },
        };

    case SuitabilitySantanderAction.generateFittingProfileSuitabilityError:
      return {
        ...state,
          fitting: {
            data: null,
            pending: false,
            error: action.payload,
          },
        };

    case SuitabilitySantanderAction.getUserInvestorTypeSuitability:
      return {
        ...state,
          investorType: {
            data: initialGenericState.investorType.data,
            pending: true,
            error: null,
          },
      };

    case SuitabilitySantanderAction.getUserInvestorTypeSuitabilitySuccess:
      return {
        ...state,
        investorType: {
          data: action.payload,
          pending: false,
          error: null,
        },
      };

    case SuitabilitySantanderAction.getUserInvestorTypeSuitabilityError:
      return {
        ...state,
          investorType: {
            data: initialGenericState.investorType.data,
                    pending: false,
                    error: action.payload,
            },
      };

    case SuitabilitySantanderAction.acceptFittingProfileSuitability:
      return {
        ...state,
          fittingAccept: {
            data: null,
            pending: true,
            error: null,
        },
    };

    case SuitabilitySantanderAction.acceptFittingProfileSuitabilitySuccess:
      return {
        ...state,
          fittingAccept: {
            data: action.payload,
            pending: false,
            error: null,
          },
    };

    case SuitabilitySantanderAction.acceptFittingProfileSuitabilityError:
      return {
        ...state,
          fittingAccept: {
            data: null,
            pending: false,
            error: action.payload,

        },
      };

    default:
      return state;
  }
}
